import { faker } from '@faker-js/faker'

import { PayMethodType, PurchaseInformation } from '../../contracts/payment'

export const createPurchase = (override: Partial<PurchaseInformation> = {}): PurchaseInformation => ({
  id: faker.number.int(),
  hospital: {
    id: faker.number.int(),
    name: faker.word.noun(),
    thumbnailImageUrl: faker.image.url(),
  },
  purchaser: {
    id: faker.number.int(),
    name: faker.word.noun(),
    phoneCountryCode: faker.location.countryCode(),
    phoneNationalNumber: '01012345678',
  },
  campaign: {
    id: faker.number.int(),
    title: faker.word.noun(),
    thumbnailImageUrl: faker.image.url(),
  },
  purchaseItems: [
    {
      product: { id: faker.number.int(), name: faker.word.noun() },
      bundle: { id: faker.number.int(), name: faker.word.noun() },
      items: [
        {
          id: faker.number.int(),
          name: faker.word.noun(),
          price: faker.number.int(),
          currency: faker.helpers.arrayElement<string>(['KRW', 'JPY']),
        },
      ],
      pricing: {
        price: 60000,
        discount: 20000,
        discountPercent: 33,
        salePrice: 40000,
        currency: faker.helpers.arrayElement<string>(['KRW', 'JPY']),
      },
      quantity: 1,
    },
  ],
  options: [
    {
      id: faker.number.int(),
      content: faker.word.noun(),
      checked: faker.datatype.boolean(),
    },
  ],
  pricing: {
    price: 60000,
    discount: 20000,
    discountPercent: 33,
    salePrice: 40000,
    currency: faker.helpers.arrayElement<string>(['KRW', 'JPY']),
  },
  payment: {
    methodType: faker.helpers.enumValue(PayMethodType),
    method: faker.string.uuid(),
  },
  status: 'INITIALIZE',
  purchasedAtDateTime: new Date().toISOString(),
  purchaseUid: faker.string.uuid(),
  cancelPolicyUrl: '',
  isUnsealed: false,
  cancelInfo: {
    cancelActorType: faker.helpers.arrayElement(['USER', 'HOSPITAL']),
    cancelReasonCode: faker.helpers.arrayElement([
      'WAITED_LONG_TIME',
      'CHANGED_TREATMENT',
      'MISMATCHED_USER_INFO',
      'OTHER',
    ]),
    cancelReasonDetail: faker.string.uuid(),
    canceledAtDateTime: new Date().toISOString(),
  },
  rewardPoint: {
    amount: 1000,
    currency: faker.helpers.arrayElement<string>(['KRW', 'JPY']),
    state: faker.string.uuid(),
    stateLabel: faker.string.uuid(),
  },
  ...override,
})
